export const formatTableLabel = (name: string, sectorName?: string | null): string =>
  sectorName ? `${name} · ${sectorName}` : name;
